import { Icon, Button, FormLayout, TextField, Tooltip, Popover, Autocomplete, ContextualSaveBar, InlineStack, BlockStack, Text, Divider, Select } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import { SearchMinor, DeleteMinor, PlusMinor, RefreshMajor } from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../../Core';
import { Switch } from 'antd';
import useContextualSaveBar, { isAdminLoggedIn } from '../../../Panel/index';
import { getLastSyncInformation } from '../../ConfigHelper';
import { RenderSkeletonCancellation } from '../../skeleton/skeleton';
import { useTranslation } from 'react-i18next';

const defaultOrderSettings = {
    "refund_reason_map": false,
    "sync_order_cancellation_status": false,
    "include_refund_in_cancelled_order": false,
    'default_cancel_reason_enabled': true,
    'restock_inventory_on_cancellation':false,
    "default_cancel_reason": "",
    "order_refund": false,
    "refund_reasons": [{
        "shopify_reason": "",
        "amazon_reason": "",
    }],
    "order_sync": true,
}

const defaultErrors = {
    refundReasons: []
};
interface CancellationAndRefundProps extends DIProps {
    setOrderSettingsEnabled: (e: boolean) => void;
    saveLoader: boolean;
    setSaveLoader: (e: boolean) => void;
    getLoader: boolean;
    setGetLoader: (e: boolean) => void;
    showSkeleton: boolean;
    setShowSkeleton: (e: boolean) => void
}

function CancellationAndRefund(props: CancellationAndRefundProps) {
    const { t } = useTranslation();
    const { showSaveBar, hideSaveBar } = useContextualSaveBar(props);
    const { showSkeleton, setShowSkeleton, saveLoader, setSaveLoader, getLoader, setGetLoader } = props;
    const [originalData, setOriginalData] = useState<any>(JSON.parse(JSON.stringify(defaultOrderSettings)));
    const [errors, setErrors] = useState<any>(JSON.parse(JSON.stringify(defaultErrors)));
    const [showContextualSaveBar, setShowContextualSaveBar] = useState<boolean>(false);
    const [preparedData, setPreparedData] = useState<any>(JSON.parse(JSON.stringify(defaultOrderSettings)));
    const [ignoreShopifyRefundReasons, setignoreShopifyRefundReasons] = useState<string[]>([]);

    const handleData = (key: string, subkey: string, value: any) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData))
        if (subkey != "") {
            tempPreparedData[key][subkey] = value
        }
        else {
            tempPreparedData[key] = value
        }
        setPreparedData({ ...tempPreparedData });
    }

    const deselectedShopifyRefundReasons = [
        { value: 'Add custom', label: t('Add custom') },
        { value: 'Shopify Refund Reason 1', label: t('Shopify Refund Reason 1') },
        { value: 'Shopify Refund Reason 2', label: t('Shopify Refund Reason 2') },
        { value: 'Shopify Refund Reason 3', label: t('Shopify Refund Reason 3') },
        { value: 'Shopify Refund Reason 4', label: t('Shopify Refund Reason 4') },
    ];
    const deselectedAmazonRefundReasons = [
        { value: 'Amazon Refund Reason 1', label: t('Amazon Refund Reason 1') },
        { value: 'Amazon Refund Reason 2', label: t('Amazon Refund Reason 2') },
        { value: 'Amazon Refund Reason 3', label: t('Amazon Refund Reason 3') },
        { value: 'Amazon Refund Reason 4', label: t('Amazon Refund Reason 4') },
    ];

    const [amazonRefundReasons, setAmazonRefundReasons] = useState(deselectedAmazonRefundReasons);
    const [amazonRefundReasonsFromBackend, setAmazonRefundReasonsFromBackend] = useState(deselectedAmazonRefundReasons);
    const [shopifyRefundReasons, setShopifyRefundReasons] = useState(deselectedShopifyRefundReasons);
    const [shopifyRefundReasonsFromBackend, setShopifyRefundReasonsFromBackend] = useState(deselectedShopifyRefundReasons);
    const [loading, setLoading] = useState(false);
    const [uiRefundReasons, setUiRefundReasons] = useState<any>([]);
    const [lastSync, setLastSync] = useState('')

    const getLastOrderSyncDate = () => {
        let data = getLastSyncInformation(props, 'order');
        data.then((res: any) => {
            if (res?.error) props.error(t(res?.error) ?? '');
            else setLastSync(res?.date ?? '')
        })
    }

    const removeStaleValues = (obj: any) => {
        let updatedData: any = JSON.parse(JSON.stringify(obj));
        if (!updatedData.order_sync) {
            updatedData = JSON.parse(JSON.stringify({ ...defaultOrderSettings, ...obj }));
            updatedData['order_sync'] = !updatedData.hasOwnProperty('order_sync') ? true : updatedData.order_sync;
        }
        else {
            if (!updatedData.order_refund) {
                updatedData = {
                    ...updatedData,
                    refund_reason_map: JSON.parse(JSON.stringify(defaultOrderSettings.refund_reason_map)),
                    refund_reasons: JSON.parse(JSON.stringify(defaultOrderSettings.refund_reasons))
                }
            } else {
                if (!updatedData.refund_reason_map)
                    updatedData = { ...updatedData, refund_reasons: JSON.parse(JSON.stringify(defaultOrderSettings.refund_reasons)) }
            }
        }
        return updatedData;
    }

    const getOrderSettings = () => {
        setSaveLoader(true)
        props.di.POST('connector/config/getConfig', {
            "group_code": ["order"]
        }).then((response: any) => {
            setSaveLoader(false)
            setShowSkeleton(false);
            if (response?.success) {
                if (response?.data?.[0]?.group_code == "order" && response?.data?.[0]?.value && Object.keys(response?.data?.[0]?.value).length > 0) {
                    let tempPreparedData = JSON.parse(JSON.stringify(preparedData));
                    let myRefundReasons: any = [];
                    let receivedData: any = removeStaleValues(JSON.parse(JSON.stringify(response?.data?.[0]?.value)));
                    let tempErrors = JSON.parse(JSON.stringify(defaultErrors));

                    let tempIgnoreShopifyRefundReasons: any = [];
                    receivedData?.refund_reasons?.map((obj: any, index: number) => {
                        tempIgnoreShopifyRefundReasons.push(obj?.shopify_reason);
                        tempErrors.refundReasons.push({ shopify: false, amazon: false })
                        myRefundReasons.push({ ...obj, activateShopify: false, activateAmazon: false, isShopifyDisabled: true, isAmazonDisabled: true })
                    });
                    setignoreShopifyRefundReasons([...tempIgnoreShopifyRefundReasons]);

                    if (myRefundReasons.length == 0) {
                        tempErrors.refundReasons.push({ shopify: false, amazon: false })
                        setUiRefundReasons([{ "shopify_reason": "", "amazon_reason": "", activateShopify: false, activateAmazon: false, isShopifyDisabled: true, isAmazonDisabled: true }])
                    }
                    else setUiRefundReasons([...myRefundReasons]);

                    if (receivedData.hasOwnProperty('sync_order_cancellation_status')) {
                        tempPreparedData['sync_order_cancellation_status'] = receivedData['sync_order_cancellation_status'];
                    }
                    if (receivedData.hasOwnProperty('default_cancel_reason_enabled')) {
                        tempPreparedData['default_cancel_reason_enabled'] = receivedData['default_cancel_reason_enabled'];
                    }
                    if (receivedData.hasOwnProperty('restock_inventory_on_cancellation')) {
                        tempPreparedData['restock_inventory_on_cancellation'] = receivedData['restock_inventory_on_cancellation'];
                    }
                    if (receivedData.hasOwnProperty('default_cancel_reason')) {
                        tempPreparedData['default_cancel_reason'] = receivedData['default_cancel_reason'];
                    }
                    if (receivedData.hasOwnProperty('include_refund_in_cancelled_order')) {
                        tempPreparedData['include_refund_in_cancelled_order'] = receivedData['include_refund_in_cancelled_order'];
                    }
                    if (receivedData.hasOwnProperty('order_refund')) {
                        tempPreparedData['order_refund'] = receivedData['order_refund'];
                    }
                    if (receivedData.hasOwnProperty('refund_reasons')) {
                        tempPreparedData['refund_reasons'] = receivedData['refund_reasons'];
                    }
                    if (receivedData.hasOwnProperty('order_sync')) {
                        tempPreparedData['order_sync'] = receivedData['order_sync'];
                    }
                    if (receivedData.hasOwnProperty('refund_reason_map')) {
                        tempPreparedData['refund_reason_map'] = receivedData['refund_reason_map'];
                    }
                    setErrors(JSON.parse(JSON.stringify(tempErrors)));
                    setOriginalData(JSON.parse(JSON.stringify(tempPreparedData)));
                    setPreparedData(JSON.parse(JSON.stringify(tempPreparedData)));
                }
            }
            else { //front end se api call mein agar koi error hogi
                props.error(t("Oops! Some error occured while getting order settings."));
            }
        });
    }

    function getAndSetShopifyRefundReasons() {
        props.di.GET("connector/order/getRefundReasons", { "target": "shopify" }).then((response: any) => {
            if (response?.status) {
                const options = response?.message.map((elem: string) => {
                    return { label: elem, value: elem }
                })
                setShopifyRefundReasons([
                    { value: 'Add custom', label: t('Add custom') },
                    ...options])
                setShopifyRefundReasonsFromBackend([
                    { value: 'Add custom', label: t('Add custom') },
                    ...options])
            }
        })
    }

    function getAndSetAmazonRefundReasons() {
        props.di.GET("connector/order/getRefundReasons", { "target": "amazon" }).then((response: any) => {
            if (response?.status) {
                const options = response?.message.map((elem: string) => {
                    return { label: elem, value: elem }
                })
                setAmazonRefundReasons([
                    // { value: 'Add custom', label: t('Add custom') },
                    ...options])
                setAmazonRefundReasonsFromBackend([
                    // { value: 'Add custom', label: t('Add custom') },
                    ...options])
            }
        })
    }

    useEffect(() => {
        setShowSkeleton(true);
        getOrderSettings();
        getLastOrderSyncDate();
        getAndSetShopifyRefundReasons();
        getAndSetAmazonRefundReasons();
    }, []);

    useEffect(() => {
        if (Object.keys(preparedData).length > 0) {
            if (JSON.stringify(originalData) != JSON.stringify(removeStaleValues(preparedData))) setShowContextualSaveBar(true);
            else setShowContextualSaveBar(false);
        }
    }, [preparedData])

    const updateSelection = (type: string, selected: any, index: number) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData))
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (selected[0] == "Add custom") {
            if (type == "shopify") {
                tempPreparedData['refund_reasons'][index]['shopify_reason'] = '';
                uiRefundReasons[index]['shopify_reason'] = '';
                uiRefundReasons[index]['isShopifyDisabled'] = false
                uiRefundReasons[index]['activateShopify'] = false
                tempErrors['refundReasons'][index]['shopify'] = selected[0] == "";
                if (typeof ignoreShopifyRefundReasons[index] !== 'undefined') {
                    ignoreShopifyRefundReasons.splice(index, 1);
                    setignoreShopifyRefundReasons([...ignoreShopifyRefundReasons])
                }
            }
            else {
                tempPreparedData['refund_reasons'][index]['amazon_reason'] = '';
                uiRefundReasons[index]['amazon_reason'] = '';
                uiRefundReasons[index]['isAmazonDisabled'] = false
                uiRefundReasons[index]['activateAmazon'] = false
                tempErrors['refundReasons'][index]['amazon'] = selected[0] == ""
            }
        }
        else {
            if (type == "shopify") {
                tempPreparedData['refund_reasons'][index]['shopify_reason'] = selected?.[0];
                uiRefundReasons[index]['shopify_reason'] = '';
                uiRefundReasons[index]['isShopifyDisabled'] = true
                uiRefundReasons[index]['activateShopify'] = false
                tempErrors.refundReasons[index]['shopify'] = selected?.[0] == '';
                let tempIgnoreShopifyRefundReasons = tempPreparedData.refund_reasons.map((code: any) => {
                    return code.shopify_reason;
                })
                setignoreShopifyRefundReasons([...tempIgnoreShopifyRefundReasons]);
            }
            else {
                tempPreparedData['refund_reasons'][index]['amazon_reason'] = selected?.[0];
                uiRefundReasons[index]['amazon_reason'] = '';
                uiRefundReasons[index]['isAmazonDisabled'] = true
                uiRefundReasons[index]['activateAmazon'] = false
                tempErrors.refundReasons[index]['amazon'] = selected?.[0] == ''
            }
        }
        setUiRefundReasons([...uiRefundReasons])
        setPreparedData({ ...tempPreparedData })
        setErrors(JSON.parse(JSON.stringify(tempErrors)))
    }

    const addRefundReasonsRow = () => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData));
        tempPreparedData.refund_reasons.push({ "shopify_reason": "", "amazon_reason": "" });
        setPreparedData({ ...tempPreparedData })

        uiRefundReasons.push({ "shopify_reason": "", "amazon_reason": "", activateShopify: false, activateAmazon: false, isShopifyDisabled: true, isAmazonDisabled: true });
        setUiRefundReasons([...uiRefundReasons]);

        let tempErrors = JSON.parse(JSON.stringify(errors));
        tempErrors.refundReasons.push({ shopify: false, amazon: false })
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
    }

    const deleteRefundReasonsRow = (index: number) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData))
        if (uiRefundReasons.length > 1 && tempPreparedData.refund_reasons.length > 1) {
            let tempOptions = ignoreShopifyRefundReasons.filter((option: any) => option != JSON.parse(JSON.stringify(preparedData))?.refund_reasons?.[index]?.shopify_reason)
            setignoreShopifyRefundReasons([...tempOptions]);

            uiRefundReasons.splice(index, 1)
            setUiRefundReasons([...uiRefundReasons])

            tempPreparedData.refund_reasons.splice(index, 1);
            setPreparedData({ ...tempPreparedData });

            let tempErrors = JSON.parse(JSON.stringify(errors));
            tempErrors.refundReasons.splice(index, 1)
            setErrors(JSON.parse(JSON.stringify(tempErrors)));
        }
    }

    const refundUpdateText = (type: string, value: any, index: number) => {
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (type == "shopify") {
            uiRefundReasons[index]['shopify_reason'] = value;
        }
        else {
            uiRefundReasons[index]['amazon_reason'] = value;
        }
        setUiRefundReasons([...uiRefundReasons]);
        if (!loading) {
            setLoading(true);
        }
        setTimeout(() => {
            if (value === '') {
                if (type == "shopify") {
                    setShopifyRefundReasons([...(shopifyRefundReasonsFromBackend ?? deselectedShopifyRefundReasons)]);
                    tempErrors.refundReasons[index]['shopify'] = value === '';
                }
                else {
                    setAmazonRefundReasons([...(amazonRefundReasonsFromBackend ?? deselectedAmazonRefundReasons)]);
                    tempErrors.refundReasons[index]['amazon'] = value === '';
                }
                setErrors(JSON.parse(JSON.stringify(tempErrors)));
                setLoading(false);
                return;
            }
            const filterRegex = new RegExp(value, 'i');
            let resultOptions = [];
            if (type == "shopify") {
                resultOptions = shopifyRefundReasons.filter((option) =>
                    option.label.match(filterRegex),
                );
                setShopifyRefundReasons(resultOptions);
            }
            else {
                resultOptions = amazonRefundReasons.filter((option) =>
                    option.label.match(filterRegex),
                );
                setAmazonRefundReasons(resultOptions);
            }
            setLoading(false);
        }, 300);
    }

    const refundTextField = (type: string, index: number) => {
        let inputValue = '';
        let placeholder = '';
        if (type == "shopify") {
            inputValue = uiRefundReasons?.[index]?.['shopify_reason'];
            placeholder = t("Search or type shopify refund reason")
        }
        else {
            inputValue = uiRefundReasons?.[index]?.['amazon_reason'];
            placeholder = t("Search or type amazon refund reason")
        }
        return <Autocomplete.TextField
            onChange={(e: any) => refundUpdateText(type, e, index)}
            value={inputValue}
            prefix={<div><Icon source={SearchMinor} /></div>}
            placeholder={placeholder}
            label=""
            autoComplete='off'
        />;
    }

    const handleTextFieldChange = (index: number, type: string, value: string) => {
        let tempPreparedData = JSON.parse(JSON.stringify(preparedData));
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (type == "shopify") {
            tempPreparedData.refund_reasons[index]['shopify_reason'] = value
            tempErrors['refundReasons'][index]['shopify'] = value == ""
        }
        else {
            tempPreparedData.refund_reasons[index]['amazon_reason'] = value
            tempErrors['refundReasons'][index]['amazon'] = value == ""
        }
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
        setPreparedData({ ...tempPreparedData })
    }

    const newRefundMarkUp = uiRefundReasons.map((obj: any, index: number) => {
        return (
            <BlockStack gap="500" key={index}>
                <InlineStack wrap={false} blockAlign="end" gap="400">
                    <div className='Custom-Stack-Item--fill'>
                        <FormLayout>
                            <FormLayout.Group condensed>
                                <TextField
                                    id={`cancellationAndRefund_TextField_RefundReason_${obj?.shopify_reason}_${index}`}
                                    connectedLeft={
                                        <Popover
                                            sectioned
                                            active={obj['activateShopify']}
                                            activator={<Tooltip content={t('Search Shopify Refund Reasons')}><Button id={`cancellationAndRefund_Btn_Shopify_${index}`} onClick={() => handleBtnClick(index, "shopify")} icon={SearchMinor} disabled={!preparedData.order_refund || !preparedData.refund_reason_map} /></Tooltip>}
                                            onClose={obj['activateShopify'] ? () => { setTimeout(() => { handleBtnClick(index, "shopify") }, 0) } : () => { }}
                                        >
                                            <Autocomplete
                                                id={`cancellationAndRefund_Autocomplete_RefundReason_${obj?.shopify_reason}_${index}`}
                                                options={shopifyRefundReasons.filter((option: any) => ignoreShopifyRefundReasons.indexOf(option.value) == -1)}
                                                selected={obj['shopify_reason']}
                                                onSelect={(e: any) => {
                                                    updateSelection("shopify", e, index);
                                                }}
                                                loading={loading}
                                                textField={refundTextField("shopify", index)}
                                            />
                                        </Popover>
                                    }
                                    placeholder={t('Eg- Customer Return')}
                                    value={preparedData?.['refund_reasons']?.[index]?.['shopify_reason']} label={t('Shopify')} onChange={(e) => { handleTextFieldChange(index, "shopify", e) }} autoComplete="off" disabled={obj['isShopifyDisabled'] || !preparedData.refund_reason_map || !preparedData.order_refund} error={errors?.refundReasons?.[index]?.['shopify']} />

                                <TextField
                                    id={`cancellationAndRefund_TextField_RefundReason_${obj?.amazon_reason}_${index}`}
                                    connectedLeft={
                                        <Popover
                                            sectioned
                                            active={obj['activateAmazon']}
                                            activator={<Tooltip content={t('Search Amazon Refund Reasons')}><Button id={`cancellationAndRefund_Btn_Amazon_${index}`} onClick={() => handleBtnClick(index, "amazon")} icon={SearchMinor} disabled={!preparedData.order_refund || !preparedData.refund_reason_map} /></Tooltip>}
                                            onClose={obj['activateAmazon'] ? () => { setTimeout(() => { handleBtnClick(index, "amazon") }, 0) } : () => { }}
                                        >
                                            <Autocomplete
                                                id={`cancellationAndRefund_Autocomplete_RefundReason_${obj?.amazon_reason}_${index}`}
                                                options={amazonRefundReasons}
                                                selected={obj['amazon_reason']}
                                                onSelect={(e: any) => updateSelection("amazon", e, index)}
                                                loading={loading}
                                                textField={refundTextField("amazon", index)}
                                            />
                                        </Popover>
                                    }
                                    placeholder={t('Eg- No Return')}
                                    value={preparedData?.['refund_reasons']?.[index]?.['amazon_reason']} label={t('Amazon')} onChange={(e) => { handleTextFieldChange(index, "amazon", e) }} autoComplete="off" disabled={obj['isAmazonDisabled'] || !preparedData.refund_reason_map || !preparedData.order_refund} error={errors?.refundReasons?.[index]?.['amazon']} />
                            </FormLayout.Group >
                        </FormLayout>
                    </div>
                    {uiRefundReasons.length > 1 && <Button id='cancellationAndRefund_Btn_DeleteReason' onClick={() => deleteRefundReasonsRow(index)} icon={DeleteMinor} disabled={!preparedData.order_sync || !preparedData.refund_reason_map || !preparedData.order_refund} />}
                </InlineStack>
            </BlockStack>
        );
    })

    const handleBtnClick = (index: number, type: string) => {
        if (type == "shopify") {
            uiRefundReasons[index]['activateShopify'] = !uiRefundReasons[index]['activateShopify']
            uiRefundReasons.forEach((_: any, idx: any) => {
                if (idx !== index)
                    uiRefundReasons[idx]['activateShopify'] = false;
                uiRefundReasons[idx]['activateAmazon'] = false
            })
        }
        else {
            uiRefundReasons[index]['activateAmazon'] = !uiRefundReasons[index]['activateAmazon']
            uiRefundReasons.forEach((_: any, idx: any) => {
                if (idx !== index)
                    uiRefundReasons[idx]['activateAmazon'] = false
                uiRefundReasons[idx]['activateShopify'] = false;
            })
        }

        setUiRefundReasons([...uiRefundReasons])
    }

    const validator = () => {
        let hasError = false;
        let tempErrors = JSON.parse(JSON.stringify(errors));
        if (preparedData.order_sync) {
            if (preparedData.order_refund && preparedData.refund_reason_map) {
                preparedData.refund_reasons.forEach((obj: any, index: number) => {
                    if (obj['shopify_reason'] == '' || obj['shopify_reason'].trim().length == 0) {
                        hasError = true;
                        tempErrors.refundReasons[index]['shopify'] = obj['shopify_reason'] == '' || obj['shopify_reason'].trim().length == 0
                    }
                    if (obj['amazon_reason'] == '' || obj['amazon_reason'].trim().length == 0) {
                        hasError = true;
                        tempErrors.refundReasons[index]['amazon'] = obj['amazon_reason'] == '' || obj['amazon_reason'].trim().length == 0
                    }
                })
            }
        }
        return { hasError, tempErrors };
    }

    function filterEditedData(original: any, changed: any) {
        const allSettings = Object.keys(defaultOrderSettings);
        const myObj: any = {};
        allSettings.forEach((setting: string) => {
            if (JSON.stringify(changed[setting]) != JSON.stringify(original[setting])) {
                myObj[setting] = changed[setting];
            }
        });
        return myObj;
    }

    const prepareBackendData = () => {
        let tempPreparedData = removeStaleValues(JSON.parse(JSON.stringify(preparedData)));

        const editedData = filterEditedData(originalData, tempPreparedData);
        let backendData = [
            {
                data: JSON.parse(JSON.stringify(editedData)),
                group_code: "order"
            }
        ];
        setPreparedData({ ...tempPreparedData })
        return backendData;
    }

    const handleDiscardBtn = () => {
        setErrors(JSON.parse(JSON.stringify(defaultErrors)));
        setShowSkeleton(true);
        setShowContextualSaveBar(false);
        setPreparedData(JSON.parse(JSON.stringify(defaultOrderSettings)));
        setignoreShopifyRefundReasons([]);
        getOrderSettings();
        getLastOrderSyncDate();
    }

    const handleSave = () => {
        setSaveLoader(true);
        const { hasError, tempErrors: receivedErrors } = validator();
        if (!hasError) {
            let backendData = prepareBackendData();
            props.di.POST('connector/config/saveConfig', {
                "data": backendData
            }).then((response: any) => {
                setShowContextualSaveBar(false);
                setSaveLoader(false);
                if (response?.success) {
                    props.success(t("Order settings saved successfully."));
                }
                else { //api call mein agar koi error hogi
                    props.error(t(response?.message) ?? t("Oops! Some error occured while saving."));
                }
                getOrderSettings();
                getLastOrderSyncDate();
            })
        }
        else {
            props.error(t("Some information is missing or wrong, kindly check them before proceeding."));
            setSaveLoader(false);
            setErrors(JSON.parse(JSON.stringify(receivedErrors)));
        }
    }

    //Contextual Save Bar of App Bridge
    if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) {
        let savebar_options: any = {
            loading: saveLoader,
        };
        if (showContextualSaveBar) {
            showSaveBar(handleDiscardBtn, handleSave, { ...savebar_options });
        } else hideSaveBar();
    }

    // To remove Errors while resetting indivisually
    const removeErrors = (key: string) => {
        let tempErrors = JSON.parse(JSON.stringify(errors))
        if (key === "") {
            if (tempErrors?.customTag) {
                tempErrors.customTag = false;
            }
        }
        else {
            tempErrors?.[key]?.map((obj: any) => {
                if (obj.amazon || obj.shopify) {
                    obj.amazon = false;
                    obj.shopify = false;
                }
            });
        }
        setErrors(JSON.parse(JSON.stringify(tempErrors)));
    }

    return showSkeleton ? RenderSkeletonCancellation() :
        <>
            {showContextualSaveBar && (process.env.REACT_APP_PROD === "0" ||
                isAdminLoggedIn()) && (
                    <ContextualSaveBar
                        message={t("Unsaved changes")}
                        saveAction={{
                            onAction: () => handleSave(),
                            loading: saveLoader,
                            disabled: false,
                        }}
                        discardAction={{
                            onAction: () => { handleDiscardBtn() },
                        }}
                    />
                )}

            <BlockStack gap="500">
                <BlockStack gap="200">
                    <Text variant="headingMd" as="h6" id='cancellationAndRefund_Text_CancellationAndRefundHeading'>
                        {t("Cancellation and Refund")}
                    </ Text>
                    <Text as="p" fontWeight="regular" id='cancellationAndRefund_Text_CancellationAndRefundDescription'>
                        {t("Sync cancelled and refund orders from Amazon to Shopify and map cancellation and refund reasons to ensure proper order syncing on both platforms")}
                    </Text>
                </BlockStack>
                <Divider />
                <InlineStack gap="200" wrap={false}>
                    <Switch className='switcherBtn' id='cancellationAndRefund_Switch_SyncCancelledOrdersOnShopify' size='small' onChange={(e: boolean) => handleData("sync_order_cancellation_status", "", e)} checked={preparedData.sync_order_cancellation_status} />
                    <BlockStack gap="100">
                        <div className='Custom__Line--Height'>
                            <Text variant="headingSm" as="h6" id='cancellationAndRefund_Text_SyncCancelledOrdersOnShopify'>
                                {t("Sync cancelled orders on Shopify")}
                            </Text>

                        </div>
                        <Text as="p" fontWeight="regular" tone='subdued' id='cancellationAndRefund_Text_SyncCancelledOrdersOnShopifyDescription'>
                            {t("Sync cancelled orders from Amazon to Shopify.")}
                        </Text>
                        <BlockStack gap="400">
                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='cancellationAndRefund_Switch_SyncCancelledOrdersOnShopify' size='small' onChange={(e: boolean) => handleData("restock_inventory_on_cancellation", "", e)} checked={preparedData.restock_inventory_on_cancellation} disabled={!preparedData.sync_order_cancellation_status} />
                                <BlockStack gap="200">
                                    <div className='Custom__Line--Height'>
                                        <Text variant="headingSm" as="h6" id='cancellationAndRefund_Text_SyncCancelledOrdersOnShopify'>
                                            {t("Re-stock Inventory on Cancellation")}
                                        </Text>

                                    </div>
                                </BlockStack>
                            </InlineStack>
                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='cancellationAndRefund_Switch_SyncCancelledOrdersOnShopify' size='small' onChange={(e: boolean) => handleData("default_cancel_reason_enabled", "", e)} checked={preparedData.default_cancel_reason_enabled} disabled={!preparedData.sync_order_cancellation_status} />
                                <BlockStack gap="200">
                                    <div className='Custom__Line--Height'>
                                        <Text variant="headingSm" as="h6" id='cancellationAndRefund_Text_SyncCancelledOrdersOnShopify'>
                                            {t("Default reason for cancellation")}
                                        </Text>

                                    </div>
                                    <Select label={undefined} disabled={!preparedData.default_cancel_reason_enabled || !preparedData.sync_order_cancellation_status} placeholder={t('Choose default reason for cancellation')} onChange={(e) => handleData("default_cancel_reason", "", e)} value={preparedData.default_cancel_reason} options={[{
                                        label: t("Customer"), value: "Customer"
                                    },
                                    {
                                        label: t("Declined"), value: "Declined"
                                    },
                                    {
                                        label: t("Fraud"), value: "Fraud"
                                    },
                                    {
                                        label: t("Inventory"), value: "Inventory"
                                    },
                                    {
                                        label: t("Other"), value: "Other"
                                    },
                                    {
                                        label: t("Staff"), value: "Staff"
                                    }]}></Select>
                                </BlockStack>
                            </InlineStack>
                        </BlockStack>

                    </BlockStack>
                </InlineStack>

                <InlineStack gap="200" wrap={false}>
                    <Switch className='switcherBtn' id='cancellationAndRefund_Switch_SyncRefundedOrdersOnShopify' size='small' onChange={(e: boolean) => {
                        handleData("order_refund", "", e)
                        if (!e) { removeErrors('refundReasons') }
                    }}
                        checked={preparedData.order_refund} />
                    <BlockStack gap="300">
                        <BlockStack gap="100">
                            <div className='Custom__Line--Height'>
                                <Text variant="headingSm" as="h6" id='cancellationAndRefund_Text_SyncRefundedOrdersOnShopify'>
                                    {t("Refunded orders")}
                                </Text>
                            </div>
                            <Text as="p" fontWeight="regular" tone='subdued' id='cancellationAndRefund_Text_SyncRefundedOrdersOnShopifyDescription'>
                                {t("Sync refunded orders from Shopify to Amazon.")}
                            </Text>
                        </BlockStack>
                        <BlockStack gap="200">
                            <InlineStack gap="200" wrap={false}>
                                <Switch className='switcherBtn' id='cancellationAndRefund_Switch_RefundReasons' size='small' onChange={(e: boolean) => {
                                    if (!e) { removeErrors('refundReasons') }
                                    handleData("refund_reason_map", "", e)
                                }
                                } checked={preparedData.refund_reason_map} disabled={!preparedData.order_sync || !preparedData.order_refund} />
                                <BlockStack gap="100">
                                    <Text variant="headingSm" as="h6" id='cancellationAndRefund_Text_RefundReasons'>
                                        {t("Map refund reasons")}
                                    </Text>
                                    <Text as="p" fontWeight="regular" tone='subdued' id='cancellationAndRefund_Text_RefundReasonsDescription'>
                                        {t(`Match Shopify's refund reasons with corresponding, predefined reasons on Amazon to avoid refund failures. When processing refunds from Shopify to Amazon, it's crucial to align the refund reasons. For example, if Shopify has a reason like 'Customer returned due to product mismatch,' but Amazon only recognizes 'Size mismatch,' ensure a mapping between them. Match Shopify's refund reasons with corresponding, predefined reasons on Amazon to avoid refund failures.`)}
                                    </Text>
                                </BlockStack>
                            </InlineStack>
                            <div className='Custom__TextField--alignmnet'>
                                <BlockStack gap="100">
                                    {newRefundMarkUp}
                                </BlockStack>
                            </div>
                            <div>
                                <Button id='cancellationAndRefund_Btn_AddReason' onClick={addRefundReasonsRow} icon={PlusMinor} disabled={!preparedData.order_refund || !preparedData.refund_reason_map}>{t("Add Reason")}</Button>
                            </div>
                        </BlockStack>
                    </BlockStack>
                </InlineStack>
                {lastSync && <>
                    <Divider />
                    <InlineStack blockAlign='center' align='space-between' gap="200">
                        <div className='Custom__Sync--Update'>
                            <InlineStack gap="200" wrap={false}>
                                <div>
                                    <Icon source={RefreshMajor} tone="base" />
                                </div>
                                <Text variant="headingSm" as="h6" tone='subdued'>
                                    {t("Last Sync Update")}: {lastSync}
                                </Text>
                            </InlineStack>
                        </div>
                    </InlineStack>
                </>}
            </BlockStack>
        </>
};
export default DI(CancellationAndRefund);